import { render, staticRenderFns } from "./MetrcDetails.template.vue?vue&type=template&id=9811bfcc&scoped=true&"
var script = {}
import style0 from "./MetrcDetails.template.vue?vue&type=style&index=0&id=9811bfcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9811bfcc",
  null
  
)

export default component.exports